<template>
  <div class="follow">
    <CubePage type="myorder-view" title="我的优惠券" :backurl="'/My'">
      <div slot="content" class="contenthb">
        <!-- <van-tabs v-model="active" sticky background="#edf0f4" color="#f0b86e" @change="onChanageTab">
          <van-tab :key="index" v-for="(item,index) in tabls" :title="item"></van-tab>
        </van-tabs> -->
        <div class="content">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh()">
            <van-empty v-if="retData.length == 0" description="暂无记录" />
            <van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
              :immediate-check="false">
              <div class="van-coupon" v-for="item in retData" :key="item.id">
                <div class="van-coupon__content">
                  <div class="van-coupon__head">
                    <h2 class="van-coupon__amount">{{item.reward_value}}<span>元</span></h2>
                    <p class="van-coupon__condition">{{item.type_text}}</p>
                  </div>
                  <div class="van-coupon__body">
                    <p class="van-coupon__name">{{item.reward_name}}</p>
                    <p class="van-coupon__valid">过期时间：{{item.expire_time}}</p>
                    <div role="checkbox" class="van-checkbox van-coupon__corner">
                      <div>x{{item.number}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </CubePage>
  </div>
</template>

<script>
  import CubePage from "../TP/cube-page.vue";
  import * as util from "@/utils/network";
  export default {
    components: {
      CubePage
    },
    data() {
      return {
        tabls: ["全部", "待发放", "已发放"],
        active: 0,
        retData: [],
        loading: false,
        finished: false,
        pageIndex: 1,
        pageTotal: 0,
        refreshing: false,
        isNoData: false
      };
    },
    created() {
      this.getData();
    },
    methods: {
      // onChanageTab(name, value) {
      //   this.clearContainer();
      //   this.getData();
      //   console.log(name, value)
      //   console.log(this.active)
      // },
      //下拉刷新
      onRefresh() {
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态

        this.refreshing = true;
        this.getData();
      },
      onLoad() {
        let that = this;
        // 异步更新数据
        that.pageIndex++;
        setTimeout(() => {
          that.getData();
        }, 100);
      },
      getData() {
        var url = "/addons/litestore/api.coupon/myCouponList";
        let that = this;
        if (that.refreshing) {
          that.clearContainer();
          that.refreshing = false;
        }
        if (that.pageIndex > 1 && that.retData.length >= that.pageTotal) {
          that.finished = true;
          return;
        }
        this.loading = true;
        var params = {
          page: that.pageIndex,
          limit: 10
        };
        //这里直接调用网络接口
        util.get(url, params, function(result) {
          console.log("object", result);
          that.loading = false;
          //这里对状态 进行分类
          that.pageTotal = result.data.total;
          if (that.pageTotal < 1) {
            that.isNoData = true;
            return;
          }
          if (result.data.list == null || result.data.list.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          that.retData = that.retData.concat(result.data.list);
          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.retData.length >= that.pageTotal) {
            that.finished = true;
          }
          // if (result.data) {
          //   //   that.show = result.data.total > 0 ? true : false;
          //   that.retData = result.data;
          //   console.log(that.retData);
          // }
        });
      }, // 初始化数据
      clearContainer() {
        this.loading = false;
        this.finished = false;
        this.retData = [];
        this.isNoData = false;
        this.pageIndex = 1;
        this.pageTotal = 0;
      }
    }
  };
</script>
<style lang="less" scoped="scoped">
  /deep/ .cube-page>.wrapper {
    background-color: rgb(255, 255, 255);
  }

  .content {
    padding: 10px;
    box-sizing: border-box;
  }
</style>
